import React, {createContext} from 'react'
import ReactDOM from 'react-dom/client'
import {Toaster} from "react-hot-toast"
import {registerLocale, setDefaultLocale} from "react-datepicker"
import {ko} from "date-fns/locale"
import {BrowserRouter} from "react-router-dom"
import reportWebVitals from 'reportWebVitals'
import {MainRouter} from "pages/main/MainRouter"
import {QueryClient, QueryClientProvider} from "react-query";
import {rootStore} from "store/useRootStore";

registerLocale("ko", ko)
setDefaultLocale("ko")

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            retry: false,
            staleTime: 5 * 60 * 1000,
        },
    },
})

export const StoreContext = createContext(rootStore)
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <StoreContext.Provider value={rootStore}>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <Toaster position="top-right"/>
                    <MainRouter/>
                </QueryClientProvider>
            </BrowserRouter>
        </StoreContext.Provider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
